<template>
    <footer class="footer">
        <div class="footer-content">
            <!-- 左侧Logo区域 -->
            <div class="footer-left">
                <div class="logo">
                    <img src="../assets/images/17.png" alt="博亿购" />
                    <!-- <p>买全球·卖全球</p> -->
                </div>
            </div>

            <!-- 中间导航区域 -->
            <div class="footer-center">
                <div class="footer-links">
                    <h3>新手指南</h3>
                    <ul>
                        <li><router-link to="/register">注册账户</router-link></li>
                        <li><router-link to="/seller">成为商家</router-link></li>
                        <li><a href="https://app.bykjy.com/automatic/m13759.agreement/content?id=15"
                                target="_blank">规则说明</a></li>
                        <li><a href="https://app.bykjy.com/automatic/m13759.agreement/content?id=16"
                                target="_blank">平台功能</a></li>
                        <li><a href="https://app.bykjy.com/automatic/m13759.agreement/content?id=17"
                                target="_blank">在线交易</a></li>
                    </ul>
                </div>
                <div class="footer-links">
                    <h3>产品服务</h3>
                    <ul>
                        <li><router-link to="/">找供应</router-link></li>
                        <li><router-link to="/">找采购</router-link></li>
                        <li><router-link to="/">看行情</router-link></li>
                    </ul>
                </div>
                <div class="footer-links">
                    <h3>关于博亿购</h3>
                    <ul>
                        <li><router-link to="/about">关于我们</router-link></li>
                        <li><a href="https://app.bykjy.com/automatic/m13759.agreement/content?id=1"
                                target="_blank">服务协议</a></li>
                        <li><a href="https://app.bykjy.com/automatic/m13759.agreement/content?id=2"
                                target="_blank">隐私政策</a></li>
                        <li><router-link to="/feedback">意见反馈</router-link></li>
                        <li><router-link to="/Complaint">用户投诉</router-link></li>
                    </ul>
                </div>
                <div class="footer-links">
                    <h3>合作联系</h3>
                    <ul>
                        <li><a>商务洽谈 {{ systemParams.tel1 }}</a></li>
                        <li><a>广告推广 {{ systemParams.tel }}</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- 底部版权区域 -->
        <div class="footer-bottom">
            <div class="container">
                <div style="display: flex; align-items: center; justify-content: center;">
                    <div>盐城市城南新区新都街道人民南路5号国际创投中心南楼5086室（CND）</div>
                    <div style="margin: 0 10px;">|</div>
                    <div v-html="systemParams.app_icp"></div>
                    <div style="margin: 0 10px;">|</div>
                    <div @click="openLicense" style="cursor: pointer;">营业执照</div>
                </div>
                <p>Copyright©2023 盐城搏亿能源科技发展有限公司 版权所有</p>
            </div>
        </div>
        <!-- 打开营业执照图片 -->
        <el-dialog title="营业执照" :visible.sync="licenseVisible" width="50%">
            <div v-html="systemParams.license"></div>
        </el-dialog>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            systemParams: {},
            licenseVisible: false
        }
    },
    mounted() {
        this.getSystemParams();
    },
    methods: {
        openLicense() {
            this.licenseVisible = true;
        },
        getSystemParams() {
            this.$api.getSystemParams({}).then(res => {
                this.systemParams = res;
            }).catch(err => {
                this.$message.error(err);
            })
        }
    }
}
</script>

<style scoped>
.footer {
    background-color: #000000;
    color: #ffffff;
    padding: 30px 0 0;
}

.footer-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    padding: 0 20px;
}

.footer-left {
    flex: 0 0 auto;
    margin-right: 50px;
    padding-right: 50px;
    border-right: 1px solid #333333;
}

.logo img {
    /* width: 156px; */
    height: 80px;
    margin-bottom: 10px;
}

.logo p {
    color: #ffffff;
    font-size: 14px;
    margin: 0;
}

.footer-center {
    flex: 1;
    display: flex;
    justify-content: space-between;
}

.footer-links {
    flex: 1;
    min-width: 150px;
}

.footer-links h3 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #ffffff;
}

.footer-links ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.footer-links ul li {
    margin-bottom: 10px;
}

.footer-links ul li a {
    color: #cccccc;
    text-decoration: none;
    font-size: 14px;
}

.footer-links ul li a:hover {
    color: #286CED;
}

.footer-bottom {
    background-color: #232323;
    padding-top: 20px;
    margin-top: 20px;
    padding-bottom: 20px;
    border-top: 1px solid #333333;
}

.footer-bottom .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    text-align: center;
}

.footer-bottom p {
    color: #999999;
    font-size: 12px;
    margin: 5px 0;
}
</style>